import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeJson',
  standalone: true,
})
export class SafeJsonPipe implements PipeTransform {
  transform(value: any): string {
    try {
      const str = JSON.stringify(value, null, 2);
      return str.length > 10000 ? str.slice(0, 10000) + '... (truncated)' : str;
    } catch (e) {
      return 'Error in JSON stringification';
    }
  }
}